module.exports = __webpack_public_path__ + "img/jwcy1.fa47199b.png";